import styled from "@emotion/styled";

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  height: ${(props) => props.theme.components.navBarHeight};
`;

export default LogoContainer;
